export default __webpack_public_path__ + "static/media/Bjorn_W.04ccfdf7.png";